import type { Menu } from '@/menus/types.ts';
export default [
  {
    code: 'MY_TODO',
    public: true,
    icon: 'menu-my-todo',
    label: '我的待办',
    path: '/my-todo',
  },
] satisfies Menu[];
